import { Routes } from '@angular/router';
import { CanMatchAdmin } from '../../../../app/can-match/can-match-admin';
import { CanMatchCompany } from '../../../../app/can-match/can-match-company';
import { CanMatchIndividual } from '../../../../app/can-match/can-match-individual';
import { adminRoutes } from '../../../../app/admin/admin.routes';
import { companyRoutes } from '../../../../app/company/company.routes';
import { individualRoutes } from '../../../../app/individual/individual.routes';

export const appLayoutRoutes: Routes = [
  {
    /** Administrator role */
    path: 'admin',
    canMatch: [CanMatchAdmin],
    children: [...adminRoutes],
  },
  {
    /** Company (LegalEntity) role */
    path: 'company',
    canMatch: [CanMatchCompany],
    children: [...companyRoutes],
  },
  {
    /** Individual role */
    path: 'individual',
    canMatch: [CanMatchIndividual],
    children: [...individualRoutes],
  },
];
